var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.6667C27 22.2855 26.751 22.879 26.3077 23.3166C25.8644 23.7542 25.2632 24 24.6364 24H3.36364C2.73676 24 2.13556 23.7542 1.69229 23.3166C1.24903 22.879 1 22.2855 1 21.6667V8.83333C1 8.21449 1.24903 7.621 1.69229 7.18342C2.13556 6.74583 2.73676 6.5 3.36364 6.5H8.09091L10.4545 3H17.5455L19.9091 6.5H24.6364C25.2632 6.5 25.8644 6.74583 26.3077 7.18342C26.751 7.621 27 8.21449 27 8.83333V21.6667Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20C16.7614 20 19 17.7614 19 15C19 12.2386 16.7614 10 14 10C11.2386 10 9 12.2386 9 15C9 17.7614 11.2386 20 14 20Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.f62044e54bf11f894e6e3e013842c55a.svg";
export { ForwardRef as ReactComponent };